import { Typography } from "@/design-system/Atoms";
import { LinkArrowButton } from "@/design-system/Atoms/Button/LinkButton";
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/routes.config";

export const TrimixPriceOverviewSection = () => {
  const navigate = useNavigate();

  const { ctaButtonConfig, patientEntitlementsIsLoading } =
    usePatientCTAButtonConfig();
  return (
    <section className="container mx-auto px-4">
      <div className="flex flex-col lg:flex-row items-center justify-center">
        <div className="w-full mt-12 lg:mt-0 lg:pr-6 lg:w-1/2 order-2 lg:order-1 lg:h-[51rem]">
          <img
            src="/images/trimix/f15ec6831469b0613fc3cb523a63306a.jpg"
            alt="Trimix treatment"
            className="h-[27.6875rem] object-cover mb-3 lg:mb-0 rounded-[20px] lg:h-full"
          />
        </div>

        <div className="w-full px-6 lg:w-[41.666667%] text-left order-1 lg:order-2 lg:ml-[8.333333%]">
          <Typography variant="categoryText" as="div" className="mb-[3.125rem]">
            Overview
          </Typography>
          <Typography variant="sectionHeading" as="h2" className="mb-10">
            <>
              Simple and Affordable Access to{" "}
              <span className="text-gray-400">Trimix</span>
            </>
          </Typography>
          <Typography variant="sectionDescriptionLarge" as="p" className="mb-4">
            Getting the treatment you need shouldn’t be complicated or
            expensive. We’ve made it easy to access trusted ED medications,
            focusing on affordability, privacy, and professional care.
          </Typography>
          <ul className="list-disc pl-8 mb-4 space-y-2">
            <li>Effective medication at a fraction of the cost.</li>
            <li>
              Simple online ordering and doorstep delivery in plain packaging.
            </li>
            <li>
              Free shipping on subscription orders or any orders above $100.
            </li>
          </ul>

          <LinkArrowButton
            href=""
            label={ctaButtonConfig.text} 
            onClick={() => {
              if (ctaButtonConfig.text === "View Products") {
                navigate(`${ROUTES.PRODUCTS_BASE}/category/ICP`);
              } else {
                ctaButtonConfig.action();
              }
            }}
            loading={patientEntitlementsIsLoading}
            className="mt-10 !w-[65%] hover:!w-[65%]"
          />
        </div>
      </div>
    </section>
  );
};

export default TrimixPriceOverviewSection;
